import React from 'react';
import Header from './header';
import Footer from './footer';
import '../css/layout.css';

const Layout = ({ children }) => {
  return (
    <div
      style={{
        maxWidth: `2000px`,
        position: 'relative',
        minHeight: 'inherit',
        margin: 'auto',
      }}
    >
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
